import { FiltroUsuariosPipe } from './filtro-usuarios.pipe';
import { FiltroClientesPipe } from './filtro-clientes.pipe';
import { FiltroDadosTransacionaisPipe } from './filtro-dados-transacionais.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltroPontoFisicoPipe } from './filtro-ponto-fisico.pipe';
import { FiltroSetoresPipe } from './filtro-setores.pipe';
import { FiltroProcessosPipe } from './filtro-processos.pipe';
import { FiltroRegioesPipe } from './filtro-regioes.pipe';
import { FiltroRoteirosPipe } from './filtro-roteiros.pipe';
import { FiltroRotinasPipe } from './filtro-rotinas.pipe';
import { FiltroGrupoAcessoPipe } from './filtro-grupo-acesso.pipe';
import { FiltroFuncionalidadePipe } from './filtro-funcionalidade.pipe';
import { FiltroIndicadoresPipe } from './filtro-indicadores.pipe';
import { FiltroDashboardsPipe } from './filtro-dashboards.pipe';
import { FiltroDashboardUsuariosPipe } from './filtro-dashboard-usuarios.pipe';
import { FiltroOcorrenciaPontoFisicoPipe } from './filtro-ocorrencia-ponto-fisico.pipe';
import { FiltroRotinaClientePipe } from './filtro-rotina-cliente.pipe';
import { FiltroUsuariosFuncionalidadePipe } from './filtro-usuarios-funcionalidade.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [FiltroClientesPipe, FiltroUsuariosPipe, FiltroPontoFisicoPipe, FiltroSetoresPipe,
    FiltroProcessosPipe, FiltroRotinasPipe, FiltroDashboardUsuariosPipe,
    FiltroRoteirosPipe, FiltroRegioesPipe, FiltroGrupoAcessoPipe, FiltroUsuariosFuncionalidadePipe,
    FiltroFuncionalidadePipe, FiltroIndicadoresPipe, FiltroDadosTransacionaisPipe, FiltroDashboardsPipe,
    FiltroOcorrenciaPontoFisicoPipe, FiltroRotinaClientePipe],
  exports: [FiltroClientesPipe, FiltroUsuariosPipe, FiltroPontoFisicoPipe, FiltroSetoresPipe,
    FiltroProcessosPipe, FiltroRotinasPipe, FiltroDashboardUsuariosPipe,
    FiltroRoteirosPipe, FiltroRegioesPipe, FiltroGrupoAcessoPipe, FiltroUsuariosFuncionalidadePipe,
    FiltroFuncionalidadePipe, FiltroIndicadoresPipe, FiltroDadosTransacionaisPipe, FiltroDashboardsPipe,
    FiltroOcorrenciaPontoFisicoPipe, FiltroRotinaClientePipe]
})
export class PipesModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/pipes.module.ts